import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withModifiers as _withModifiers, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8c421684"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "base-info" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Filter data with computed properties. Compare this code with the code from ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("filtering with basic methods")
const _hoisted_4 = { class: "contain" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Blog Posts", -1))
const _hoisted_6 = { class: "new" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Add a New Post", -1))
const _hoisted_8 = ["onSubmit"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Add a New label", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { type: "submit" }, "Add New Blog Post", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Filter with a label", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "none", -1))
const _hoisted_13 = { class: "label" }

import { computed, ref } from 'vue'

interface Post {
  author: string,
  title: string,
  label: string
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const selected = ref('')
const posts = ref([
        {
          author: '@vFitzgerald',
          title: 'Quod Ducimus Omnis',
          label: 'science'
        },
        {
          author: '@mPalmer',
          title: 'Vero Eius Laboriosam Ex Repudiandae',
          label: 'math'
        },
        {
          author: '@mDean',
          title: 'Magnam Odit',
          label: 'science'
        },
        {
          author: '@tCole',
          title: 'Velit Mollitia Voluptates Assumenda',
          label: 'science'
        },
        {
          author: '@jCooper',
          title: 'Eum Commodi Cupiditate',
          label: 'poetry'
        },
        {
          author: '@lLamb',
          title: 'Amet',
          label: 'history'
        },
        {
          author: '@fMartin',
          title: 'Voluptatem Fuga Cum Asperiores Error',
          label: 'science'
        },
        {
          author: '@eHayes',
          title: 'Ipsa Consectetur Rerum Repellat Quia',
          label: 'math'
        },
        {
          author: '@cCollier',
          title: 'Dolor Nihil Delectus',
          label: 'science'
        },
        {
          author: '@cBenson',
          title: 'Labore Ipsum Ad Pariatur',
          label: 'poetry'
        }
      ]);
const categories = ref([
        "Science",
        "Math",
        "Poetry",
        "History"
      ]);
const newTitle = ref('');
const newAuthor = ref('');
const newLabel = ref('');
const addPost = () => {
  let addedPost = {
    author: newAuthor.value,
    title: newTitle.value,
    label: newLabel.value
  };
  posts.value.push(addedPost);
  newAuthor.value = '',
      newTitle.value = '',
      newLabel.value = ''
};

const filterByLabel = computed (() => {
  let filter = new RegExp(selected.value, 'i');
  return posts.value.filter((post: Post) => post.label.match(filter))
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("p", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_router_link, { to: "/methods" }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("form", {
          onSubmit: _withModifiers(addPost, ["prevent"])
        }, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newTitle).value = $event)),
            placeholder: "title",
            required: ""
          }, null, 512), [
            [_vModelText, newTitle.value]
          ]),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newAuthor).value = $event)),
            placeholder: "author name",
            required: ""
          }, null, 512), [
            [_vModelText, newAuthor.value]
          ]),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newLabel).value = $event)),
            required: ""
          }, [
            _hoisted_9,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (category) => {
              return (_openBlock(), _createElementBlock("option", { key: category }, _toDisplayString(category), 1))
            }), 128))
          ], 512), [
            [_vModelSelect, newLabel.value]
          ]),
          _hoisted_10
        ], 40, _hoisted_8)
      ]),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selected).value = $event))
      }, [
        _hoisted_11,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (category) => {
          return (_openBlock(), _createElementBlock("option", { key: category }, _toDisplayString(category), 1))
        }), 128)),
        _hoisted_12
      ], 512), [
        [_vModelSelect, selected.value]
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filterByLabel), (post) => {
        return (_openBlock(), _createElementBlock("div", {
          key: post.title,
          class: "post"
        }, [
          _createElementVNode("span", _hoisted_13, _toDisplayString(post.label), 1),
          _createElementVNode("p", null, _toDisplayString(post.title), 1),
          _createElementVNode("small", null, _toDisplayString(post.author), 1)
        ]))
      }), 128)),
      _createElementVNode("pre", null, _toDisplayString(_unref(filterByLabel)), 1)
    ])
  ], 64))
}
}

})